/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A platform tool advertised by the embedding host (WebMCP) for the LLM to call.
 * 
 * Tools execute in the browser, not the backend. Field names mirror the MCP
 * wire shape the frontend sends (notably camelCase ``inputSchema``). No
 * ``annotations`` field: approval gating (e.g. ``readOnlyHint``) is enforced
 * frontend-side and never reaches the backend.
 * @export
 * @interface McpTool
 */
export interface McpTool {
    /**
     * 
     * @type {string}
     * @memberof McpTool
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof McpTool
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof McpTool
     */
    inputSchema?: { [key: string]: any; };
}

/**
 * Check if a given object implements the McpTool interface.
 */
export function instanceOfMcpTool(value: object): value is McpTool {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function McpToolFromJSON(json: any): McpTool {
    return McpToolFromJSONTyped(json, false);
}

export function McpToolFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpTool {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'inputSchema': json['inputSchema'] == null ? undefined : json['inputSchema'],
    };
}

export function McpToolToJSON(json: any): McpTool {
    return McpToolToJSONTyped(json, false);
}

export function McpToolToJSONTyped(value?: McpTool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'inputSchema': value['inputSchema'],
    };
}

